module.exports = function () {
    var getSize = function (element, type, width) {
        var selection = $(element).closest('div:regex(class, span\d*)'); //select span
        var module = d3.select(selection[0]);
        var span = module.attr('class');
        if (module.attr('default-height') === 'true') {
            span = null;
        }
        var width = selection.width();
        var height = 0; // 0 so it doesn't break incase there's no match (it just won't show)
        // i'm putting the differen't visuals' switches in functions so having switches within switches doesn't get confusing
        function pieChart(width) {
            switch (span) {
                case 'span5':
                    return width/2.3;
                case 'span4':
                    return width/1.65;
                // case 'span6':
                //     return width/2.4
                default:
                    return width/2.3; // anything that would be appropriate as a default here
            }
        }
        function barChart(width) {
            switch (span) {
                case 'span7':
                    return width/3;
                case 'span8':
                    return width/11;
                case 'span12':
                    return width/10;
                default:
                    return width/4; // anything that would be appropriate as a default here
            }
        }
        function linechart(width) {
            switch (span) {
                case 'span12':
                    return width/10.5;
                case 'span11':
                    return width/8.5;
                case 'span8':
                    return width/7;
                case 'span7':
                    return width/3.3;
                case 'span6':
                    return width/3;
                case 'span10':
                    return width/6;
                default:
                    return width/4; // anything that would be appropriate as a default here
            }
        }
        function curvegraph(width) {
            switch (span) {
                case 'span12':
                    return width/10.5;
                case 'span11':
                    return width/8.5;
                case 'span8':
                    return width/12;
                case 'span7':
                    return width/3.3;
                case 'span6':
                    return width/3;
                case 'span10':
                    return width/6;
                default:
                    return width/4; // anything that would be appropriate as a default here
            }
        }
        function geoChart(width) {
            switch (span) {
                case 'span5':
                    return width/2;
                default:
                    return width/2; // anything that would be appropriate as a default here
            }
        }
        switch (type) {
            case 'pieChart':
                return {
                    width: width,
                    height: pieChart(width)
                }
            break;
            case 'barChart':
                return {
                    width: width,
                    height: barChart(width)
                }
            break;
            case 'linechart':
                return {
                    width: width,
                    height: linechart(width)
                }
            break;
            case 'curvegraph':
                return {
                    width: width,
                    height: curvegraph(width)
                }
            break;
            case 'rowChart':
                return {
                    width: width,
                }
            break;
            case 'geoChart':
                return {
                    width: width,
                    height: geoChart(width)
                }
            break;
            default:
                return {
                    height: height,
                    width: width
                }
        }
    }
    return getSize;
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/getsize.js
 **/